export default __webpack_public_path__ + "static/media/spa.27102e00.png";